import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FiArrowRight } from "react-icons/fi";
import TopBar from "../components/TopBar";
import Header from "../components/headerfooter/Header";
import Footer from "../components/headerfooter/Footer";
import CallToAction from "../components/home/CallToAction";
import Breadcrumb from "../components/Breadcrumb";
import MobileFooter from "../components/MobileFooter";
import { IMAGE_URL, REACT_APP_API_PORT } from "../Api";
import axios from "axios";

const AnimeCartoonGenerator = (props) => {
  const navigate = useNavigate()
  const [data, setData] = useState([]);
  const [totalTool, settotalTool] = useState(0);
  const [isLoading, setisLoading] = useState(false);
  const getData = async () => {
      try {
        setisLoading(true);
        let id = localStorage.getItem('FCID')
        const res = await axios.get(`${REACT_APP_API_PORT}user/homepage/subcategory_by_category/${id}`);
        setisLoading(false);
        if (res.data.status) {
          setData(res.data.data);
          settotalTool(res.data.totalToolCount)
        }

      }
      catch (err) {
          setisLoading(false)
          console.log(err)
      }
  }

  useEffect(() => {
    getData();
  }, []);
  const tools = [
    {
      id: "CI1",
      name: "🖊️ Article Writing",
      image: "https://www.aitoolsbazaar.com/_next/image?url=https%3A%2F%2Faitoolsbazaar-image.s3.ap-south-1.amazonaws.com%2Fcategory%2F1724647810417-chat-gpt.webp&w=640&q=75",
      toolCount: 25,
    },
    {
      id: "CI2",
      name: "🖐 Text Humanize",
      image: "https://www.aitoolsbazaar.com/_next/image?url=https%3A%2F%2Faitoolsbazaar-image.s3.ap-south-1.amazonaws.com%2Fcategory%2F1724648823160-text%2520Humanize.webp&w=640&q=75",
      toolCount: 20,
    },
    {
      id: "CI3",
      name: "🕸️ Chat GPT",
      image: "https://www.aitoolsbazaar.com/_next/image?url=https%3A%2F%2Faitoolsbazaar-image.s3.ap-south-1.amazonaws.com%2Fcategory%2F1724647746884-Article%2520Writing.webp&w=640&q=75",
      toolCount: 10,
    },
    {
      id: "CI4",
      name: "🔠 Translate",
      image: "https://www.aitoolsbazaar.com/_next/image?url=https%3A%2F%2Faitoolsbazaar-image.s3.ap-south-1.amazonaws.com%2Fcategory%2F1724649026909-Translate.webp&w=640&q=75",
      toolCount: 25,
    },
    {
      id: "CI5",
      name: "📜 Captions or Subtitle",
      image: "https://www.aitoolsbazaar.com/_next/image?url=https%3A%2F%2Faitoolsbazaar-image.s3.ap-south-1.amazonaws.com%2Fcategory%2F1724647738412-caption%2520or%2520subtitle.webp&w=640&q=75",
      toolCount: 23,
    },
    {
      id: "CI6",
      name: "📜 Captions or Subtitle",
      image: "https://www.aitoolsbazaar.com/_next/image?url=https%3A%2F%2Faitoolsbazaar-image.s3.ap-south-1.amazonaws.com%2Fcategory%2F1724647738412-caption%2520or%2520subtitle.webp&w=640&q=75",
      toolCount: 21,
    },
  ];

  const handleNavigate = (id,label,toolCount)=>{
    if(toolCount < 1){
      props.setAlertBox(true)
      props.showAlert("No Tools Available", "warning")
      return false 
    }
    localStorage.setItem('FSID',id)

    navigate(`/subcategory/${label}`)
  }

  return (
    <>
      {/* <TopBar /> */}
      <Header />
      <Breadcrumb title={data?.category?.category_name} breadcrumbs={[{ label: data?.category?.category_name }]} paragraph="Discover the Newest AI Tools Transforming Innovation." />

      <section className="bg-background-back1 pt-4 pb-14 overflow-hidden">
        

        {/* ✅ Swiper Removed, Using Grid Layout */}
        <div className="container max-w-[80rem] mx-auto px-4">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {data && data?.subcategories?.length > 0 && data?.subcategories?.map((item) => (
              <div key={item._id} onClick={()=>handleNavigate(item._id,item?.subcategory_label,item.toolCount)} className="transition-transform duration-300 ease-in-out hover:scale-105 cursor-pointer">
                <div className="w-full border border-gray-800 bg-background-back2 rounded-xl overflow-hidden">
                <div className=" w-full overflow-hidden">
                  <img 
                    src={item?.image ? IMAGE_URL + item?.image + "?type=subcategory" : "/category.png"} 
                    onError={(e) => {
                    e.target.onerror = null; // Prevents infinite loop if default image fails
                    e.target.src = '/category.png';
                  }}
                    alt={item?.sub_category_name} 
                    className="w-full h-full object-cover"
                  />
                </div>
                  <div className="p-3">
                    <h5 className="text-sm sm:text-base text-white truncate">{item.sub_category_name}</h5>
                    <p className="text-xs text-primary mt-1">{item.toolCount} tools</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <CallToAction />
      <Footer />
      <MobileFooter />
    </>
  );
};

export default AnimeCartoonGenerator;
